import { useQuery } from '@tanstack/react-query';
import { useShippingMethodsApi } from './use-shipping-methods-api';

/**
 * Query key for getting a single shipping method
 */
const QK_GET_SHIPPING_METHOD = (id: string) => ['shipping-methods', id] as const;

export function useShippingMethod(id: string) {
  const { shippingMethodsApi } = useShippingMethodsApi();

  return useQuery({
    queryKey: QK_GET_SHIPPING_METHOD(id),
    queryFn: () => shippingMethodsApi.shippingMethod(id).get(),
  });
}
